import React from 'react';
import { TARIFF_COMMODITIES } from './constants';
import { ChipLead, ChipRow, FilterChip } from './blocks';

const CommodityChips = ({ counts, selected, onToggle }) => (
    <ChipRow role="group" aria-label="Filter by commodity">
        {TARIFF_COMMODITIES.map(({ value, label }) => (
            <FilterChip
                key={value}
                type="button"
                aria-pressed={selected.includes(value)}
                onClick={() => onToggle(value)}
            >
                <ChipLead>{counts[value] ?? 0}</ChipLead> {label}
            </FilterChip>
        ))}
    </ChipRow>
);

export default CommodityChips;
